import { captureException } from '@sentry/react';
import axios from 'axios';

import { toApiServiceError } from '@/services/http/errors';

export const unauthorizedAxiosInstance = axios.create({
    baseURL: import.meta.env.PROD ? 'https://api.countercyclical.io' : 'http://localhost:3000',
    timeout: 2500,
    withCredentials: true,
});

unauthorizedAxiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        const apiError = toApiServiceError(error);

        if (!error?.config?.suppressErrorCapture) {
            captureException(apiError);
        } else {
            Object.assign(apiError, { suppressErrorCapture: true });
        }

        return Promise.reject(apiError);
    },
);
